<template>
    <div>
        <div v-if="files2 != null && files2.length > 0" class="m-b-10">
            <draggable v-model="files2" @change="orderChanged">
                <div v-for="(f, _f) in files2">
                    <img v-lazy="'/image/2/' + f.filename" />
                    <button type="button" class="btn btn-small" @click.prevent="remove(_f)">x</button>
                </div>
            </draggable>
        </div>

        <vue-clip :options="options" :on-complete="complete" v-show="(maxFiles == 0 || (files2.length < maxFiles))">
            <template slot="clip-uploader-action" slot-scope="params">
                <div v-bind:class="{'is-dragging': params.dragging}" class="upload-action upload-action-well">
                    <div class="dz-message">
                        <h2><span class="icon-upload icon-white"></span> {{ uploadText }}</h2>
                    </div>
                </div>
            </template>
        </vue-clip>
    </div>
</template>

<script>
    import VueClip from 'vue-clip'
    import Vue from 'vue'
    import VueLazyload from 'vue-lazyload'
    import draggable from 'vuedraggable'

    Vue.use(VueClip)
    Vue.use(draggable)

    Vue.use(VueLazyload, {
        preLoad: 1.3,
        //error: 'dist/error.png',
        loading: '/Content/Main/Images/loading.gif',
        attempt: 1
    })

    export default {
        name: 'uploader',
        components: {
            draggable
        },
        props: {
            files: {
                required: true,
            },
            maxFiles: {
                type: Number,
                required: true
            }
        },
        watch: {
            files() {
                this.files2 = this.files;
            }
        },
        data() {
            var self = this;
            return {
                files2: self.files,
                options: {
                    url: '/admin/upload/',
                    paramName: 'file',
                    parallelUploads: 1,
                    autoProcessQueue: true
                }
            }
        },
        computed: {
            uploadText() {
                var self = this;
                if (self.maxFiles == 1) {
                    return "Nahrát obrázek...";
                } else {
                    return "Nahrát obrázky...";
                }
            }
        },
        methods: {
            orderChanged() {
                var self = this;
                self.$emit('files-updated', self.files2);
            },
            remove(idx) {
                var self = this;
                self.files2 = self.files2.filter((item, index) => {
                    return index != idx;
                });
                self.$emit('files-updated', self.files2);
            },
            complete(file, status, xhr) {
                var self = this;
                if (status == 'success') {
                    self.files2.push(JSON.parse(xhr.response));
                    self.$emit('files-updated', self.files2);
                }
            }
        }
    }
</script>

<style>
    .upload-action.is-dragging {
        background: green;
    }

    .upload-action-well {
        min-height: 20px;
        padding: 19px;
        margin: 0 0 20px 0;
        background-color: #333;
        color: #FFF;
        border: 1px solid #eee;
        border: 1px solid rgba(0, 0, 0, 0.05);
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
        -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
        display: inline-block;
    }

    .m-b-10 {
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// _uploader.vue?1d451b9f